module.exports = __webpack_public_path__ + "first-10_hologram.jpg?b56234adb411fbd4e13b16b08c3bc34d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/first-10_hologram.jpg
// module id = 443
// module chunks = 0